import { render, staticRenderFns } from "./CompCreateUser.vue?vue&type=template&id=eefd2800&scoped=true"
import script from "./CompCreateUser.vue?vue&type=script&lang=js"
export * from "./CompCreateUser.vue?vue&type=script&lang=js"
import style0 from "./CompCreateUser.vue?vue&type=style&index=0&id=eefd2800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefd2800",
  null
  
)

export default component.exports